import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBashdouDYkprJDxkvesq1u5nrNzXy5WzM",
  authDomain: "academy-of-arts.firebaseapp.com",
  projectId: "academy-of-arts",
  storageBucket: "academy-of-arts.firebasestorage.app",
  messagingSenderId: "694512596019",
  appId: "1:694512596019:web:55ae5f00fbbd8f22c91f46",
  measurementId: "G-QBEF2LXYWR"
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
// Mantiene i dati Firestore sul dispositivo: Web App e App Allievi possono
// consultare l'ultima copia scaricata anche offline e sincronizzarla al ritorno della rete.
export const db = initializeFirestore(firebaseApp, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});
export const storage = getStorage(firebaseApp);
